"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateStickerRequestDto = exports.MAX_STICKER_CAPTION_LENGTH = void 0;
const swagger_1 = require("@nestjs/swagger");
exports.MAX_STICKER_CAPTION_LENGTH = 280;
class CreateStickerRequestDto {}
exports.CreateStickerRequestDto = CreateStickerRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  maxLength: exports.MAX_STICKER_CAPTION_LENGTH,
  required: false
}), __metadata("design:type", String)], CreateStickerRequestDto.prototype, "caption", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], CreateStickerRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], CreateStickerRequestDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: '"Keep it on my profile" (true, never expires) or "Temporary" (false, 24 hours). Omitted = temporary. Sent as a multipart field, so "true"/"false" strings are accepted.'
}), __metadata("design:type", Object)], CreateStickerRequestDto.prototype, "keepOnProfile", void 0);
//# sourceMappingURL=StickerRequest.dto.js.map